import {
    ADMINGETLANGUAGELIST_SUCCESS,
    ADMINGETLANGUAGELIST_FAILED,
    RESET_ADMINGETLANGUAGELIST,
    LOADING_ADMINGETLANGUAGELIST,
    NETWORK_ERROR_ADMINGETLANGUAGELIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMINGETLANGUAGELIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMINGETLANGUAGELIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMINGETLANGUAGELIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMINGETLANGUAGELIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMINGETLANGUAGELIST:
            return (state = initialState);
        default:
            return state;
    }
};